<script>
import { breakpointsMixin } from '@mixins/breakpoints-mixin.js';

export default {
  mixins: [breakpointsMixin],
  data() {
    return {};
  },
};
</script>

<template>
  <div class="action-remove" @click="$emit('remove-exercise')">
    <span class="wrapper">
      <svg width="14" height="18" viewBox="0 0 14 18" fill="none" xmlns="http://www.w3.org/2000/svg" v-bind:class="'icon-trash'" v-bind:svg-inline="''" v-bind:role="'presentation'" v-bind:focusable="'false'" v-bind:tabindex="'-1'"><path fill-rule="evenodd" clip-rule="evenodd" d="M10.5 1H14v2H0V1h3.5l1-1h5l1 1zM3 18c-1.1 0-2-.9-2-2V4h12v12c0 1.1-.9 2-2 2H3z" fill="#000"/></svg>
      Remove <span v-if="!isXLTabletUp">Exercise</span>
    </span>
  </div>
</template>

<style lang="scss" scoped>
@import '@design';

.action-remove {
  align-items: center;
  background: rgba($color-black-one-wo-rgb, 0.05);
  border-radius: 4px;
  display: flex;
  height: fit-content;
  justify-content: center;
  margin-right: 1rem;
  padding: 1rem;
  white-space: nowrap;

  .wrapper {
    color: $color-red;
    font-size: 1.2rem;
    font-weight: 600;
    letter-spacing: 0.116667px;
    line-height: 1.9rem;

    @include media('xxxl', null) {
      font-size: 1.4rem;
    }

    &:hover {
      cursor: pointer;
    }

    .icon-trash {
      margin-right: 0.7rem;

      path {
        fill: $color-red;
      }
    }

    span {
      display: inline;

      @include media('xxxl', null) {
        display: none;
      }
    }
  }

  &:hover {
    background: rgba($color-black-one-wo-rgb, 0.15);
    cursor: pointer;
  }
}
</style>
